module.exports = require("react-responsive");


//////////////////
// WEBPACK FOOTER
// external "react-responsive"
// module id = 33
// module chunks = 0